module.exports = __webpack_public_path__ + "img/print_filled_32.c800f4dc.svg";